<ng-container *transloco="let t">

  <div class="modal-header">

    <h2>{{header}}</h2>

    <!-- hack to fool ngbModal autofocus -->
    <input type="text" style="display:none" />

    <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" aria-label="Close"
      (click)="activeModal.dismiss('Cross click')">
      <span class="svg-icon svg-icon-2x">
        <close-x-svg-icon></close-x-svg-icon>
      </span>
    </div>
  </div>

  <div class="modal-body py-10 px-lg-17">
    <form #employmentInfoForm="ngForm" class="form" novalidate id="employmentInfoForm" name="employmentInfoForm">
      <div class="me-n7 pe-7">
        <div class="row mb-5">
          <div class="col-md-6 fv-row">
            <label class="required form-label mb-2">{{ t('wizard.employment.borrower') }}</label>
            <borrower-picker #borrowerPicker [required]="true" [ngModelOptions]="{standalone: true}" [(ngModel)]="employment.borrowerId" [borrowers]="borrowers"></borrower-picker>
          </div>
          @if (!inEditMode && isMilitaryRelated) {
            <div class="col-md-6 fv-row">
              <label class="{{!isRetired ? 'required': ''}} form-label mb-2">{{ t('wizard.employment.typeOfPay') }}</label>
              <select name="militaryPayType"
                [required]="!isRetired"
                [ngClass]="{'is-invalid' : selectedMilitaryPayType && selectedMilitaryPayType.touched && selectedMilitaryPayType.invalid}"
                #selectedMilitaryPayType="ngModel"
                class="form-select form-select-solid"
                data-control="select2"
                [(ngModel)]="militaryPayType"
                data-control="select2" data-hide-search="true" data-placeholder="Select a Business Type">
                <option [ngValue]="null"></option>
                <option [ngValue]="'Employment'">{{ t('wizard.employment.employment') }}</option>
                <option [ngValue]="'Disability'">{{ t('wizard.employment.disability') }}</option>
              </select>
              <div class="invalid-feedback">{{ t('wizard.employment.militaryPayTypeRequired') }}</div>
            </div>
          }
        </div>

        @if (militaryPayType === 'Employment') {
          @if (isBusinessSelfEmployment && !isHidden('employment.businessType')) {
            <div class="row mb-5">
              <div class="col-md-12 fv-row">
                <label class="form-label mb-2" [ngClass]="{'required' : isRequired('employment.businessType') && !isRetired}">
                  {{getLabel('employment.businessType', t('wizard.employment.businessType'))}}</label>
                <select name="businessType"
                  [required]="isRequired('employment.businessType') && !isRetired"
                  [ngClass]="{'is-invalid' : businessType && businessType.touched && businessType.invalid}"
                  #businessType="ngModel" class="form-select form-select-solid" data-control="select2" [(ngModel)]="employment.businessType"
                  (ngModelChange)="onBusinessTypeChanged()"
                  data-control="select2" data-hide-search="true" data-placeholder="Select a Business Type">
                  <option></option>
                  @for (businessType of businessTypes; track businessType.value) {
                    <option value="{{businessType.value}}">
                      {{businessType.name}}
                    </option>
                  }
                </select>
                <div class="invalid-feedback">{{ t('wizard.employment.businessTypeRequired') }}</div>
              </div>
            </div>
          }
          @if (isBusinessSelfEmployment) {
            <div class="row mb-5">
              @if (isOwnershipSharePercentVisible) {
                <div class="col-md-6 fv-row">
                  @if (isOwnershipSharePercentCaptured) {
                    <label class="form-label mb-2" [ngClass]="{'required' : isRequired('employment.borrowerOwnershipSharePercent') && !isRetired}">{{getLabel('employment.borrowerOwnershipSharePercent', t('wizard.employment.ownershipSharePercent'))}}</label>
                    <input class="form-control form-control-solid"
                      mask="separator.4" thousandSeparator="," inputmode="decimal" suffix="%" separatorLimit="100"
                      [ngClass]="{'is-invalid' : borrowerOwnershipSharePercent && borrowerOwnershipSharePercent.touched && borrowerOwnershipSharePercent.invalid}"
                      #borrowerOwnershipSharePercent="ngModel"
                      [required]="isRequired('employment.borrowerOwnershipSharePercent') && !isRetired"
                      [(ngModel)]="employment!.borrowerOwnershipSharePercent" (ngModelChange)="onOwnershipSharePercentChanged()"
                      name="borrowerOwnershipSharePercent" placeholder="" />
                    <div class="invalid-feedback">{{ t('wizard.employment.ownershipSharePercentRequired') }}</div>
                  }
                  @if (!isSoleProprietor) {
                    <div class="form-check form-switch form-check-custom form-check-solid mt-3">
                      <input class="form-check-input h-20px w-30px" type="checkbox" name="doesNotKnowOwnershipSharePercent"
                        [(ngModel)]="doesNotKnowOwnershipSharePercent" (ngModelChange)="onDoesNotKnowOwnershipSharePercentChanged()"
                        id="doesNotKnowOwnershipSharePercent" />
                      <label class="form-check-label form-label" for="doesNotKnowOwnershipSharePercent">
                        {{ t('wizard.employment.doesNotKnowOwnershipSharePercent') }}
                      </label>
                    </div>
                  }
                </div>
              }
              @if (!isHidden('employment.borrowerOwnershipShare')) {
                <div class="col-md-6 fv-row">
                  <label class="form-label mb-2" [ngClass]="{'required' : isRequired('employment.borrowerOwnershipShare') && !isRetired}">{{getLabel('employment.borrowerOwnershipShare', t('wizard.employment.ownershipShare'))}}</label>
                  <select name="borrowerOwnershipShare" [ngClass]="{'is-invalid' : borrowerOwnershipShare && borrowerOwnershipShare.touched && borrowerOwnershipShare.invalid}"
                    [required]="isRequired('employment.borrowerOwnershipShare') && !isRetired"
                    [disabled]="isOwnershipSharePercentCaptured"
                    #borrowerOwnershipShare="ngModel" class="form-select form-select-solid" [(ngModel)]="employment!.borrowerOwnershipShare"
                    data-control="select2" data-hide-search="true" data-placeholder="Choose one">
                    <option></option>
                    @for (ownershipShareType of ownershipShareTypes; track ownershipShareType.value) {
                      <option value="{{ownershipShareType.value}}">
                        {{ownershipShareType.name}}
                      </option>
                    }
                  </select>
                  <div class="invalid-feedback">{{ t('wizard.employment.ownershipShareRequired') }}</div>
                </div>
              }
              @if (!isHidden('employment.selfEmploymentMonthlyIncomeOrLoss')) {
                <div class="col-md-6 fv-row">
                  <label class="form-label mb-2" [ngClass]="{'required' : isRequired('employment.selfEmploymentMonthlyIncomeOrLoss') && !isRetired}">{{getLabel('employment.selfEmploymentMonthlyIncomeOrLoss', t('wizard.employment.monthlyPay'))}}</label>
                  <input class="form-control form-control-solid"
                    [allowNegativeNumbers]="true"
                    mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
                    [ngClass]="{'is-invalid' : selfEmploymentMonthlyIncomeOrLoss && selfEmploymentMonthlyIncomeOrLoss.touched && selfEmploymentMonthlyIncomeOrLoss.invalid}"
                    #selfEmploymentMonthlyIncomeOrLoss="ngModel"
                    [required]="isRequired('employment.selfEmploymentMonthlyIncomeOrLoss') && !isRetired" [(ngModel)]="employment!.selfEmploymentMonthlyIncomeOrLoss" placeholder=""
                    name="selfEmploymentMonthlyIncomeOrLoss" />
                  <div class="invalid-feedback">{{ t('wizard.employment.monthlyIncomeLossRequired') }}</div>
                </div>
              }
            </div>
          }
          @if (isBusinessSelfEmployment && !isHidden('employment.selfEmploymentForm') && employment.borrowerOwnershipShare === ownerShipShareTypeGreaterOrEqualTo25Percent) {
            <div class="row mb-5">
              <div class="col-md-6 fv-row">
                <label class="form-label mb-2" [ngClass]="{'required' : isRequired('employment.selfEmploymentForm') && !isRetired}">{{getLabel('employment.selfEmploymentForm', t('wizard.employment.selfEmploymentForm'))}}</label>
                <select name="selfEmploymentForm" [ngClass]="{'is-invalid' : selfEmploymentForm && selfEmploymentForm.touched && selfEmploymentForm.invalid}"
                  [required]="isRequired('employment.selfEmploymentForm') && !isRetired"
                  #selfEmploymentForm="ngModel" class="form-select form-select-solid" [(ngModel)]="employment!.selfEmploymentForm"
                  data-control="select2" data-hide-search="true" data-placeholder="Choose one">
                  <option></option>
                  @for (selfEmploymentForm of selfEmploymentForms; track selfEmploymentForm.value) {
                    <option value="{{selfEmploymentForm.value}}">
                      {{selfEmploymentForm.name}}
                    </option>
                  }
                </select>
                <div class="invalid-feedback">{{ t('wizard.employment.selfEmploymentFormRequired') }}</div>
              </div>
            </div>
          }
          <div class="row mb-5">
            @if (!isHidden('employment.employer')) {
              <div class="col-md-6 fv-row">
                <label class="form-label mb-2" [ngClass]="{'required' : isRequired('employment.employer') && !isRetired}">{{getLabel('employment.employer', t('wizard.employment.employerName'))}}</label>
                @if (employment.address && employment.address.country && employment.address.country !== 'us') {
                  <input type="text" class="form-control form-control-solid"
                    [required]="isRequired('employment.employer') && !isRetired"
                    [disabled]="isRetired"
                    [ngClass]="{'is-invalid' : employer && employer.touched && employer.invalid}" #employer="ngModel"
                    [(ngModel)]="employment.employer" placeholder="" name="employer" id="employer" />
                } @else {
                  <address-autocomplete-v2
                    [required]="isRequired('employment.employer') && !isRetired"
                    [disabled]="isRetired"
                    [includedPrimaryTypes]="['establishment','point_of_interest']"
                    [placeholder]="t('wizard.employment.employer')"
                    (addressSelected)="onEmployerSelected($event)"
                    #employer="ngModel"
                    [(ngModel)]="employment.employer"
                    name="employer"
                    id="employer">
                  </address-autocomplete-v2>
                }
                <div class="invalid-feedback">{{ t('wizard.employment.employerNameRequired') }}</div>
              </div>
            }
            @if (!isHidden('employment.isPrimary')) {
              <div class="col-md-6 fv-row">
                <label class="form-label mb-2" [ngClass]="{'required' : isRequired('employment.isPrimary') && !isRetired}">{{getLabel('employment.isPrimary', t('wizard.employment.jobType'))}}</label>
                <select name="jobType" [ngClass]="{'is-invalid' : jobType && jobType.touched && jobType.invalid}"
                  [required]="isRequired('employment.isPrimary') && !isRetired"
                  #jobType="ngModel" class="form-select form-select-solid" [(ngModel)]="employment!.isPrimary"
                  data-control="select2" data-hide-search="true" data-placeholder="Choose one">
                  @for (jobType of jobTypes; track jobType.value) {
                    <option value="{{jobType.value}}">
                      {{ t(jobType.labelKey) }}
                    </option>
                  }
                </select>
                <div class="invalid-feedback">{{ t('wizard.employment.jobTypeRequired') }}</div>
              </div>
            }
          </div>

          <div class="row mb-5">
            @if (!isHidden('employment.position')) {
              <div class="col-md-6 fv-row">
                <label class="form-label mb-2" [ngClass]="{'required' : isRequired('employment.position') && !isRetired}">{{getLabel('employment.position', t('wizard.employment.position'))}}</label>
                <input type="text" class="form-control form-control-solid"
                  [ngClass]="{'is-invalid' : position && position.touched && position.invalid}" #position="ngModel"
                  [(ngModel)]="employment!.position" placeholder="" name="position"
                  [required]="isRequired('employment.position') && !isRetired" />
                <div class="invalid-feedback">{{ t('wizard.employment.positionRequired') }}</div>
              </div>
            }
            @if (!isHidden('employment.employmentType')) {
              <div class="col-md-6 fv-row">
                <label class="form-label mb-2" [ngClass]="{'required' : isRequired('employment.employmentType')}">{{getLabel('employment.employmentType', t('wizard.employment.currentOrFormer'))}}</label>
                <select name="employmentType" [required]="isRequired('employment.employmentType')"
                  [ngClass]="{'is-invalid' : currentOrFormer && currentOrFormer.touched && currentOrFormer.invalid}"
                  #currentOrFormer="ngModel" class="form-select form-select-solid" [(ngModel)]="employment!.employmentType"
                  data-control="select2" data-hide-search="true" data-placeholder="Choose one">
                  <option></option>
                  <option value="CurrentEmployer">{{ t('wizard.employment.currentEmployer') }}</option>
                  <option value="FormerEmployer">{{ t('wizard.employment.formerEmployer') }}</option>
                </select>
                <div class="invalid-feedback">{{ t('wizard.employment.pleaseSelectValue') }}</div>
              </div>
            }
          </div>

          @if (!isIndependentContractor) {
            <div class="row">
              <address
                [address]="employment.address"
                [showCountry]="showCountry"
                [required]="!isRetired"
                [isDialogView]="true"
                [fieldConfigSettings]="employmentAddressFieldConfigSettings"
                [fieldsToConfig]="fieldsToConfig"
                (countryChanged)="onCountryChanged($event)">
              </address>
            </div>
          }

          <div class="row g-9 mb-5">
            @if (!isHidden('employment.employerPhone')) {
              <div class="col-md-6 fv-row">
                <label class="form-label mb-2" [ngClass]="{'required' : isRequired('employment.employerPhone') && !isRetired}">{{getLabel('employment.employerPhone', t('wizard.employment.corporatePhone'))}}</label>
                <input class="form-control form-control-solid" [(ngModel)]="employment!.employerPhone"
                  [required]="isRequired('employment.employerPhone') && !isRetired"
                  [ngClass]="{'is-invalid' : phone && phone.touched && phone.invalid}" #phone="ngModel"
                  placeholder="" mask='(000) 000-0000' name="corporatePhone" />
              </div>
            }
            @if (!isHidden('employment.yearsInLineOfWork')) {
              <div class="col-md-6 fv-row">
                <label class="form-label mb-2" [ngClass]="{'required' : isRequired('employment.yearsInLineOfWork') && !isRetired}">{{getLabel('employment.yearsInLineOfWork', t('wizard.employment.yearsInProfession'))}}</label>
                <input class="form-control form-control-solid" [patterns]="integerPattern" mask="XY" [validation]="false"
                  [required]="isRequired('employment.yearsInLineOfWork') && !isRetired"
                  [ngClass]="{'is-invalid' : years && years.touched && years.invalid}" #years="ngModel"
                  [(ngModel)]="employment!.yearsInLineOfWork" placeholder="" name="years" />
                <div class="invalid-feedback">{{ t('wizard.employment.yearsInProfessionRequired') }}</div>
              </div>
            }
          </div>
          <div>
            @if (isCurrent || isPrevious) {
              <div class="row g-9 mb-5">
                @if (!isHidden('employment.startDate')) {
                  <div class="col-md-6 fv-row">
                    <label class="form-label mb-2" [ngClass]="{'required' : isRequired('employment.startDate')}">{{getLabel('employment.startDate', t('wizard.employment.startDate'))}}</label>
                    <input class="form-control form-control-solid" matInput mask="00/00/0000" [showMaskTyped]="true" [specialCharacters]="[ '/' ]"
                      [dropSpecialCharacters]="false" inputmode="numeric"
                      [ngClass]="{'is-invalid' : startDate && startDate.touched && startDate.invalid}" #startDate="ngModel"
                      [required]="isRequired('employment.startDate')" inputmode="numeric"
                      [(ngModel)]="employment!.startDate" placeholder="" name="startDate" ngControl="startDate" id="startDate"
                      datePicker/>
                    <div [ngStyle]="{'display':startDate && startDate.touched && startDate.invalid ? 'block' : 'none' }" class="invalid-feedback">{{ t('wizard.employment.startDateRequired') }}</div>
                  </div>
                }

                @if (isPrevious && !isHidden('employment.endDate')) {
                  <div class="col-md-6 fv-row">
                    <label class="form-label mb-2" [ngClass]="{'required' : isRequired('employment.endDate') && !isRetired}">{{getLabel('employment.endDate', t('wizard.employment.endDate'))}}</label>

                    <input class="form-control form-control-solid"  matInput mask="00/00/0000" [showMaskTyped]="true"
                      [specialCharacters]="[ '/' ]" [dropSpecialCharacters]="false" datePicker inputmode="numeric"
                      [ngClass]="{'is-invalid' : endDate && endDate.touched && endDate.invalid}" #endDate="ngModel" datePicker
                      [required]="isRequired('employment.endDate') && !isRetired" inputmode="numeric"
                      [(ngModel)]="employment!.endDate" placeholder="" name="endDate" ngControl="endDate" id="endDate"  />
                      <div [ngStyle]="{'display':endDate && endDate.touched && endDate.invalid ? 'block' : 'none' }" class="invalid-feedback">{{ t('wizard.employment.endDateRequired') }}</div>
                      <div [ngStyle]="{'display':endDate && endDate.touched && isEndDateMessageShowing ? 'block' : 'none' }" class="invalid-feedback">{{ t('wizard.employment.endDateMustBeGreater') }}</div>
                      <div [ngStyle]="{'display':endDate && endDate.touched && isEndDateInFutureMessageShowing ? 'block' : 'none' }" class="invalid-feedback">{{ t('wizard.employment.endDateInFuture') }}</div>
                  </div>
                }
                @if (!isPrevious) {
                  <div class="col-md-6 fv-row">
                  </div>
                }
              </div>
            }
          </div>
          <div class="row g-9 mb-5">
            @if (!isBusinessSelfEmployment && !isHidden('monthlyPay')) {
              <div class="col-md-6 fv-row">
                <label class="form-label mb-2" [ngClass]="{'required' : isRequired('monthlyPay') && !isRetired}">{{getLabel('monthlyPay', t('wizard.employment.monthlyPay'))}}</label>
                <input class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
                  [ngClass]="{'is-invalid' : monthlyPay && monthlyPay.touched && monthlyPay.invalid}"
                  #monthlyPay="ngModel"
                  [required]="isRequired('monthlyPay') && !isRetired" [(ngModel)]="employment!.monthlyIncome" placeholder="" name="monthlyPay" />
                <div class="invalid-feedback">{{ t('wizard.employment.monthlyPayRequired') }}</div>
              </div>
            }
            <div class="col-md-3 fv-row">
              <div class="form-check form-switch form-check-custom form-check-solid" style="padding-top: 30px;">
                <input class="form-check-input h-20px w-30px" type="checkbox" name="isRetired" [(ngModel)]="isRetired" (ngModelChange)="isRetiredChanged()" id="isRetired" />
                <label class="form-check-label form-label" for="isRetired">
                  {{ t('wizard.employment.isRetired') }}
                </label>
              </div>
            </div>
            @if (isIndependentContractor && !isHidden('employment.selfEmployed')) {
              <div class="col-md-3 fv-row">
                <div class="form-check form-switch form-check-custom form-check-solid" style="padding-top: 30px;">
                  <input class="form-check-input h-20px w-30px" [(ngModel)]="employment!.selfEmployed"
                  [required]="isRequired('employment.selfEmployed') && !isRetired"
                  [ngModelOptions]="{standalone: true}"
                  type="checkbox"  id="selfEmployed" />
                  <label class="form-check-label form-label" [ngClass]="{'required' : isRequired('employment.selfEmployed') && !isRetired}" for="selfEmployed">
                    {{getLabel('employment.selfEmployed', t('wizard.employment.selfEmployed'))}}
                  </label>
                </div>
              </div>
            }
          </div>
        }
        @if (militaryPayType === 'Disability') {
          <div class="row g-6 mb-5">
            @if (!isBusinessSelfEmployment && !isHidden('monthlyPay')) {
              <div class="col-md-6 fv-row">
                <label class="form-label mb-2" [ngClass]="{'required' : isRequired('monthlyPay')}">{{getLabel('monthlyPay', t('wizard.employment.monthlyPay'))}}</label>
                <input class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
                  [ngClass]="{'is-invalid' : monthlyPay && monthlyPay.touched && monthlyPay.invalid}"
                  #monthlyPay="ngModel"
                  [required]="isRequired('monthlyPay')" [(ngModel)]="employment!.monthlyIncome" placeholder="" name="monthlyPay" />
                <div class="invalid-feedback">{{ t('wizard.employment.monthlyPayRequired') }}</div>
              </div>
            }
            <div class="col-md-6 fv-row">
            </div>
          </div>
        }
      </div>
    </form>
  </div>

  <div class="modal-footer flex-center">
    <button type="button" class="btn btn-white me-3" (click)="activeModal.dismiss()">{{ t('common.cancel') }}</button>
    <button type="button" class="btn btn-primary" (click)="onSaveClicked()">{{ t('common.ok') }}</button>
  </div>

</ng-container>
